import React, { useState } from "react";
import "./LumeriaRealityVerse.css";
import { Container, Nav, Row, Col } from "react-bootstrap";
import luminaMeta from "../../Assets/Projects/Lumina-meta.png";
import realityImg from "../../Assets/Projects/realityVerse.png";
import { FiTool, FiExternalLink, FiShoppingBag, FiShoppingCart, FiPackage, FiZap, FiUserCheck } from "react-icons/fi";

function LumeriaRealityVerse() {
  const [active, setActive] = useState("lumria");

  return (
    <main id="lumeria-reality" className="project-section">
      <Container className="py-5">
        <div className="lrv-tab-wrap mb-4">
          <nav className="lrv-tabs glass p-2 rounded-3" aria-label="Lumeria Reality tabs">
            <Nav variant="tabs" activeKey={active} onSelect={(k) => setActive(k)}>
              <Nav.Item>
                <Nav.Link eventKey="lumria" className="lrv-tab">
                  Lumeria
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="reality" className="lrv-tab">
                  Reality Verse
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>
        </div>

        <div className="lrv-content glass p-4 rounded-3">
          {active === "lumria" ? (
            <section className="text-center mb-5">
              <h1 className="fw-bold fs-2 text-accent">Welcome to the Lumeria Realm</h1>
              <div className="lrv-hero-wrap">
                <img src={luminaMeta} alt="Lumina" className="lrv-hero-image mb-3" />

                <div className="lrv-role-pills" aria-hidden="false">
                  <div className="lrv-role-pill">
                    <span className="icon" aria-hidden="true">🌾</span>
                    <span className="label">Farmer — Build a farm, grow assets</span>
                  </div>

                  <div className="lrv-role-pill">
                    <span className="icon" aria-hidden="true">⚔️</span>
                    <span className="label">Warrior — Conquer quests, find artifacts</span>
                  </div>

                  <div className="lrv-role-pill">
                    <span className="icon" aria-hidden="true">⚒️</span>
                    <span className="label">Creator — Forge gear & buildings</span>
                  </div>
                </div>
              </div>
              <p className="lead text-muted mt-3">Stop being a user. Start being a founder.</p>
              <p className="text-muted">Most digital worlds treat you like a passenger — you follow their rules, play their games, and stay in your lane. In Lumeria, the "User" is dead. Here, you are an Architect.</p>

             
              {/* Roadmap / Milestones */}
              <div className="text-center mb-3">
                <h5 className="fw-bold d-inline-block h8">Dust generation apps</h5>
              </div>
              <div className="container-fluid lrv-roadmap bg-dark py-4 text-white overflow-auto mt-2">
                <div className="d-flex justify-content-between align-items-center position-relative mx-auto" style={{ minWidth: 800, maxWidth: 'var(--safe-max-width)' }}>
                  <div className="position-absolute top-50 start-0 w-100 border-top border-secondary translate-middle-y" style={{ zIndex: 0, opacity: 0.28 }} />

                  <div className="text-center position-relative milestone market" style={{ width: 150 }}>
                      <a href="https://t20.lumeriameta.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-white" aria-label="Open T20 Dust Saga">
                        <div className="rounded-circle border border-primary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3 pulse-glow" style={{ width: 60, height: 60 }}>
                          <span className="fs-4">🏏</span>
                        </div>
                        <h5 className="fw-bold mb-1 h8">T20 Dust Saga</h5>
                        <span className="badge rounded-pill bg-primary px-3">Live</span>
                      </a>
                  </div>

                  <div className="text-center position-relative milestone factory opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <span className="fs-4">⚽</span>
                    </div>
                    <h5 className="fw-bold mb-1 h8">GoalSaga</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Upcoming</span>
                  </div>

                  <div className="text-center position-relative milestone energy opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <span className="fs-4">🏀</span>
                    </div>
                    <h5 className="fw-bold mb-1 h8">HoopSaga</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Upcoming</span>
                  </div>

                  <div className="text-center position-relative milestone merchant opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <span className="fs-4">🎾</span>
                    </div>
                    <h5 className="fw-bold mb-1 h8">TennisSaga</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Upcoming</span>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section className="text-center mb-5">
              <h1 className="fw-semibold fs-2 text-accent">RealityVerse: The Bridge to Absolute Utility</h1>
              <img src={realityImg} alt="Reality Verse" className="lrv-hero-image mb-3" />


              <p className="lead text-muted mt-2">Where your digital legacy meets the physical world — commerce, merchants, and real-world utility anchored by onchain identity.</p>

            
              {/* App directory - horizontal scrollable apps */}
              <div className="app-directory lrv-roadmap  bg-dark text-light py-3 px-2 rounded-3">
                <div className="d-flex justify-content-between align-items-center mx-auto" style={{ minWidth: 600, maxWidth: 'var(--safe-max-width)' }}>
                  <div className="text-center position-relative milestone" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <FiShoppingCart className="fs-4 icon-stroke" />
                    </div>
                    <h5 className="fw-bold mb-1 h8">Marketplace</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Upcoming</span>
                  </div>

                  <div className="text-center position-relative milestone opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <FiPackage className="fs-4 icon-stroke" />
                    </div>
                    <h5 className="fw-bold mb-1 h8">Factory</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Concept</span>
                  </div>

                  <div className="text-center position-relative milestone opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <FiZap className="fs-4 icon-stroke" />
                    </div>
                    <h5 className="fw-bold mb-1 h8">Energy Farm</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Concept</span>
                  </div>

                  <div className="text-center position-relative milestone opacity-50" style={{ width: 150 }}>
                    <div className="rounded-circle border border-secondary bg-dark d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: 60, height: 60 }}>
                      <FiUserCheck className="fs-4 icon-stroke" />
                    </div>
                    <h5 className="fw-bold mb-1 h8">Merchant Lite</h5>
                    <span className="badge rounded-pill border border-secondary text-secondary px-3">Concept</span>
                  </div>
                </div>
              </div>
              <Row className="g-4 mt-4 reality-grid">
                <Col >
                  <div className="lrv-card p-4 rounded h-100 d-flex flex-column align-items-center text-center reality-card">
                    <div className="display-6 mb-3"><FiExternalLink /></div>
                    <h5 className="fw-bold mb-2">Bridge to Utility</h5>
                    <p className="text-muted">Tokenize receipts, prove ownership, and redeem real-world services via secure onchain bridges.</p>
                  </div>
                </Col>

                <Col >
                  <div className="lrv-card p-4 rounded h-100 d-flex flex-column align-items-center text-center reality-card">
                    <div className="display-6 mb-3"><FiShoppingBag /></div>
                    <h5 className="fw-bold mb-2">Sovereign Marketplace</h5>
                    <p className="text-muted">A merchant-first marketplace where creators set terms and users retain custody of assets.</p>
                  </div>
                </Col>

                <Col >
                  <div className="lrv-card p-4 rounded h-100 d-flex flex-column align-items-center text-center reality-card">
                    <div className="display-6 mb-3"><FiTool /></div>
                    <h5 className="fw-bold mb-2">Merchant Tools</h5>
                    <p className="text-muted">Easy integrations, POS plugins, and lightweight SDKs to onboard physical merchants quickly.</p>
                  </div>
                </Col>
              </Row>

              <p className="text-muted small mt-3">The RealityVerse focuses on pragmatic utility: merchant integrations, verifiable receipts, and a pathway from digital ownership to real-world value.</p>
            </section>
          )}
        </div>
      </Container>
    </main>
  );
}

export default LumeriaRealityVerse;
